import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { UserCustom } from '../../types';
import { getErrorText } from '../helpers';

type Params = { userId: string };
type Response = Pubnub.GetUUIDMetadataResponse<UserCustom>['data'];

export const getUserMetadata = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/getUserMetadata',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;

      if (pubnubReducer.pubnub) {
        const result = await pubnubReducer.pubnub.objects.getUUIDMetadata<UserCustom>({
          uuid: data.userId,
          include: {
            customFields: true,
          },
        });

        return result.data;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
